export default __webpack_public_path__ + "static/media/model.782143a3.svg";